export default {
  GET_USERS: 'GET_USERS',
  GET_ROLES: 'GET_ROLES',
  GET_ERRORS: 'GET_ERRORS',
  GET_PAGINATION: 'GET_PAGINATION'
}
